import { PayloadAction } from "@reduxjs/toolkit";
import { CartFilterItemType, CartFilterType, CartSliceState } from "../types";

export const filtersReducers = {
  setProductionFilters: (
    state: CartSliceState,
    action: PayloadAction<CartFilterType>,
  ) => {
    state.productionFilters = action.payload;
  },
  setRemainsFilters: (
    state: CartSliceState,
    action: PayloadAction<CartFilterType>,
  ) => {
    state.remainsFilters = action.payload;
  },
  setSelectedProductionFilters: (
    state: CartSliceState,
    action: PayloadAction<CartFilterItemType>,
  ) => {
    state.selectedProductionFilters = action.payload;
  },
  setSelectedRemainsFilters: (
    state: CartSliceState,
    action: PayloadAction<CartFilterItemType>,
  ) => {
    state.selectedRemainsFilters = action.payload;
  },
  clearProductionFilters: (state: CartSliceState) => {
    state.selectedProductionFilters = {};
  },
  clearRemainsFilters: (state: CartSliceState) => {
    state.selectedRemainsFilters = {};
  },
  clearCartFilters: (state: CartSliceState) => {
    state.selectedProductionFilters = {};
    state.selectedRemainsFilters = {};
  },
};
